export const categoryOptions = [
  { value: 0, label: "All Tiers", tier: "" },
  { value: 1, label: "Tier 1", tier: "tier-1" },
  { value: 2, label: "Tier 2", tier: "tier-2" },
  { value: 3, label: "Tier 3", tier: "tier-3" },
];
